<template>
  <appbar-view></appbar-view>

    <div class="main-content">

      <v-container>
        <div class="hidden sm:flex items-center space-x-3 mb-6 px-2">
          <!-- Logo -->
          <img
            src="https://mvexpress.mx/images/logosapp/logomv6.png"
            alt="Logo MV"
            class="w-19 sm:w-16 h-auto object-contain select-none"
          />

          <!-- Icono camión -->

          <!-- Título -->
          <h1 class="text-2xl font-bold text-gray-900 select-none">
            Historial de Pedidos
          </h1>
        </div>

        <!-- Tabla para pantallas grandes -->
        <!-- Tabla para pantallas grandes -->
        <div class="hidden sm:block">
          <v-data-table
            :headers="headers"
            :items="pedidos"
            :search="search"
            item-value="pedido_id"
            dense
            fixed-header
            height="auto"
            class="elevation-2 w-full"
            :items-per-page="20"
            v-model:page="page"
            :sort-by="[{ key: 'fecha_pedido', order: 'desc' }]"
          >
            <template v-slot:item="{ item, index }">
              <tr :class="index % 2 === 0 ? 'bg-gray-50' : 'bg-white'">
                <!-- <td class="px-4 py-2 text-sm font-medium text-gray-700">
                  {{ item.referencia_frog }}
                </td> -->

                <td class="px-4 py-2 text-sm text-gray-600">
                  {{ item.fecha_pedido.substring(0, 10) }}
                </td>

                <td class="px-4 py-2 text-center">
                  <v-chip :color="getStatusColor(item.estado)" size="small" label class="font-weight-bold text-uppercase">
                    {{ item.estado || 'Desconocido' }}
                  </v-chip>
                </td>
             
                <td class="px-4 py-2 text-sm text-gray-600">
                  ${{
                    Number(item.total).toLocaleString("es-MX", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </td>

                <td class="px-4 py-2 text-center">
                  <v-btn
                    variant="solo"
                    color="black"
                    small
                    class="text-gray-700 hover:bg-gray-200"
                   
                  >
                    <v-icon left size="18" class="text-blue-darken-4">mdi-eye</v-icon>
                    Ver Detalles
                  </v-btn>
                </td>
                <td class="px-4 py-2 text-sm text-gray-600">
                  {{ item.udn || "N/A" }}
                </td>
              </tr>
            </template>

            <template v-slot:footer>
              <div class="flex justify-end px-4 py-2 bg-gray-100">
                <v-pagination
                  v-model:page="page"
                  :length="Math.ceil(pedidos.length / 20)"
                  circle
                  total-visible="7"
                  color="blue-darken-4"
                />
              </div>
            </template>
          </v-data-table>
        </div>

        <!-- Lista para móviles -->
        <div class="sm:hidden flex items-center space-x-2 mt-6 mb-4 px-4">
          <v-icon class="text-blue-600" size="24">mdi-format-list-bulleted</v-icon>
          <h2 class="text-lg font-semibold text-gray-900 select-none">
            Resumen de tus pedidos
          </h2>
        </div>

        <div class="sm:hidden space-y-4 mt-4 px-4">
          <v-card
            v-for="item in pedidos"
            :key="item.pedido_id"
            class="rounded-xl elevation-3 mb-4 overflow-hidden"
        
            ripple
          >
            <!-- Encabezado de la tarjeta -->
            <div class="d-flex justify-space-between align-center pa-3 bg-grey-lighten-4" style="border-bottom: 1px solid rgba(0,0,0,0.05)">
              <div class="d-flex align-center gap-2">
                <v-icon color="blue-darken-3" size="20">mdi-package-variant-closed</v-icon>
                <!-- <span class="font-weight-bold text-subtitle-2 text-blue-grey-darken-3">#{{ item.referencia_frog }}</span> -->
              </div>
              <v-chip :color="getStatusColor(item.estado)" size="small" variant="tonal" class="font-weight-bold text-uppercase" label>
                <v-icon start size="small">{{ getStatusIcon(item.estado) }}</v-icon>
                {{ item.estado || 'Pendiente' }}
              </v-chip>
            </div>

            <!-- Contenido -->
            <div class="pa-4">
              <div class="d-flex justify-space-between mb-1">
                <span class="text-caption text-grey-darken-1">Fecha del pedido</span>
                <span class="text-body-2 font-weight-medium">{{ item.fecha_pedido.substring(0, 10) }}</span>
              </div>
              
              <div class="d-flex justify-space-between align-center mt-3 pt-2" style="border-top: 1px dashed #e0e0e0">
                <span class="text-subtitle-1 font-weight-bold text-grey-darken-3">Total</span>
                <span class="text-h6 font-weight-black text-green-darken-1">
                  ${{ Number(item.total).toLocaleString("es-MX", { minimumFractionDigits: 2 }) }}
                </span>
              </div>
            </div>
          </v-card>
        </div>

        <!-- Modal de detalles -->
        <v-dialog v-model="dialogDetalle" max-width="450" scrollable transition="dialog-bottom-transition">
          <v-card class="rounded-lg" style="background-color: #fff; position: relative; overflow: visible;">
            
            <!-- Header del Ticket -->
          <div class="d-flex flex-column align-center pt-6 pb-4 px-4 bg-grey-lighten-4" style="border-bottom: 2px dashed #e0e0e0;">
  <v-btn icon="mdi-close" variant="text" size="small" color="red" class="position-absolute top-0 right-0 mt-2 mr-2" @click="dialogDetalle = false"></v-btn>
  
  <v-img 
    src="https://mvexpress.mx/images/logosapp/logomv6.png" 
    width="120" 
    aspect-ratio="1/1"
    class="mb-3"
  ></v-img>
  
  <h3 class="text-h6 font-weight-black text-blue-grey-darken-3">TICKET DE COMPRA</h3>
  <div class="text-caption text-grey-darken-1 font-weight-medium mt-1">
    {{ detallePedido?.fecha_pedido ? detallePedido.fecha_pedido.substring(0, 10) : '' }}
  </div>
<!--   <div class="text-subtitle-2 font-weight-bold text-blue-darken-3 mt-1">
    Pedido #{{ detallePedido?.referencia_frog }}
  </div>  -->
</div>
            <!-- Cuerpo del Ticket (Scrollable) -->
            <v-card-text class="pa-0" style="max-height: 60vh;">
              <div v-if="detallePedido" class="pa-5">
                
                <!-- Status Alert inside Ticket -->
                <v-alert
                  :color="getStatusColor(detallePedido.estado)"
                  :icon="getStatusIcon(detallePedido.estado)"
                  variant="tonal"
                  density="compact"
                  class="mb-4 text-caption font-weight-bold text-uppercase text-center"
                  style="border-radius: 8px;"
                >
                  Estado: {{ detallePedido.estado || 'Pendiente' }}
                </v-alert>

                <!-- Lista de items -->
                <div class="d-flex flex-column gap-3">
                  <div v-for="(detalle, index) in detallePedido.detalles" :key="index" class="d-flex align-start py-1">
                    
                    <!-- Imagen (Nueva) -->
                    <div class="mr-3">
                        <v-avatar size="40" rounded="lg" color="grey-lighten-4">
                            <v-img :src="detalle.foto" contain></v-img>
                        </v-avatar>
                    </div>

                    <!-- Cantidad -->
                    <div class="font-weight-bold text-body-2 mr-2 pt-2" style="min-width: 24px; color: #555;">
                      {{ detalle.cantidad }}x
                    </div>
                    
                    <!-- Info Producto -->
                    <div class="flex-grow-1 pt-1">
                      <div class="text-body-2 font-weight-medium text-grey-darken-3" style="line-height: 1.2;">
                        {{ detalle.nombre }}
                      </div>
                    </div>
                    
                    <!-- Precio Total Linea -->
                    <div class="text-body-2 font-weight-bold text-right ml-2 pt-2">
                      ${{ Number(detalle.subtotal).toLocaleString("es-MX", { minimumFractionDigits: 2 }) }}
                    </div>
                  </div>
                </div>

                <!-- Separador -->
                <div class="my-5" style="border-top: 2px dashed #e0e0e0;"></div>

                <!-- Resumen -->
                <div class="d-flex justify-space-between mb-2 text-body-2 text-grey-darken-2">
                  <span>Total Artículos</span>
                  <span class="font-weight-bold">{{ detallePedido.detalles.reduce((acc, item) => acc + Number(item.cantidad), 0) }}</span>
                </div>

                <div class="d-flex justify-space-between align-center mt-4 pt-2" style="border-top: 1px solid #f5f5f5;">
                  <span class="text-h6 font-weight-bold text-blue-grey-darken-3">TOTAL</span>
                  <span class="text-h5 font-weight-black text-green-darken-1">
                    ${{ Number(detallePedido.total).toLocaleString("es-MX", { minimumFractionDigits: 2 }) }}
                  </span>
                </div>

                <!-- MV Coins (Si aplica) -->
                <div v-if="detallePedido.detalles[0]?.mv_coins_ganados > 0" class="mt-4 bg-orange-lighten-5 pa-3 rounded-lg d-flex align-center justify-center border-dashed border-orange">
                  <v-icon color="orange-darken-3" class="mr-2">mdi-star-circle</v-icon>
                  <span class="text-body-2 font-weight-bold text-orange-darken-4">
                    Ganaste {{ Number(detallePedido.detalles[0].mv_coins_ganados).toLocaleString("es-MX") }} MV Coins
                  </span>
                </div>

              </div>
            </v-card-text>

          </v-card>
        </v-dialog>

        
      </v-container>
    </div>

   <bottom-navigation />

</template>

<script>
import axios from "axios";
import appbarView from "./appbar/appbarView.vue";
import BottomNavigation from "./submenu/BottomNavigation.vue";

export default {
  components: { appbarView, BottomNavigation },
  data() {
    return {
      drawer: false,

      search: "",
      pedidos: [],
      user: {},
      headers: [
        // { key: "referencia_frog", title: "Pedido ID" },
        { key: "fecha_pedido", title: "Fecha de Pedido" },
        { key: "estado", title: "Estado" },
        { key: "total", title: "Total" },


        { key: "acciones", title: "Acciones" },
        { key: "udn", title: "UDN" }, // 👈 corregido
      ],
      page: 1,
      detallePedido: null,
      dialogDetalle: false,
    };
  },
  methods: {
    getStatusColor(status) {
      if (!status) return 'grey';
      const s = String(status).toLowerCase();
      if (s.includes('entregado') || s.includes('completado') || s.includes('finalizado')) return 'green';
      if (s.includes('cancelado') || s.includes('rechazado')) return 'red';
      if (s.includes('pendiente') || s.includes('proceso') || s.includes('preparacion')) return 'orange';
      if (s.includes('enviado') || s.includes('camino')) return 'blue';
      return 'blue-grey';
    },
    getStatusIcon(status) {
      if (!status) return 'mdi-help-circle';
      const s = String(status).toLowerCase();
      if (s.includes('entregado') || s.includes('completado') || s.includes('finalizado')) return 'mdi-check-circle';
      if (s.includes('cancelado') || s.includes('rechazado')) return 'mdi-close-circle';
      if (s.includes('pendiente') || s.includes('proceso') || s.includes('preparacion')) return 'mdi-clock-outline';
      if (s.includes('enviado') || s.includes('camino')) return 'mdi-truck-delivery';
      return 'mdi-package-variant';
    },
    obtenerDatos() {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) this.user = user;
    },
async obtenerConsultaPedidos() {
  try {
    if (!this.user || !this.user.cliente) return;

    const token = localStorage.getItem("token");

    const url = `https://mvexpress.mx/api/cliente/pedido/${this.user.cliente}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const pedidosData = Array.isArray(response.data)
      ? response.data
      : [response.data];

    this.pedidos = pedidosData.sort((a, b) => new Date(b.fecha_pedido) - new Date(a.fecha_pedido));
  } catch (error) {
    console.error("Error al obtener los pedidos:", error);
  }
},


async showProducto(pedido) {
  try {
    const token = localStorage.getItem("token");

    if (!pedido.detalles) {
      const detalleUrl = `https://mvexpress.mx/api/find/pedido/${pedido.pedido_id}`;

      const detalleResponse = await axios.get(detalleUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      pedido.detalles = detalleResponse.data;
    }

    this.detallePedido = pedido;
    this.dialogDetalle = true;
  } catch (error) {
    console.error(
      `Error al obtener detalles del pedido ${pedido.pedido_id}:`,
      error
    );
  }
}

  },
  mounted() {
    this.obtenerDatos();
    this.obtenerConsultaPedidos();
  },

  computed: {
    finalAhorro() {
      if (
        !this.detallePedido ||
        !Array.isArray(this.detallePedido.detalles) ||
        this.detallePedido.detalles.length === 0
      ) {
        return 0;
      }

      const nuevoAhorro = Number(this.detallePedido.detalles[0].ahorro) || 0;
      const total = Number(this.detallePedido.total) || 0;

      //console.log("Nuevo ahorro:", nuevoAhorro);
     // console.log("Total pedido:", total);

      const finalAhorro = nuevoAhorro - total;
      return finalAhorro;
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  /* Opcional para darle un fondo claro */
}

.main-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100vh - (64px + env(safe-area-inset-top, 30px)));
  overflow-y: auto;
  padding-bottom: calc(70px + env(safe-area-inset-bottom));
}

.v-data-table {
  width: 100%;
  overflow-x: auto;
  /* Agregado para evitar desbordamientos en pantallas pequeñas */
}

.v-dialog .v-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.v-btn {
  text-transform: none;
  padding: 6px 12px;
}

.drawer-arrow {
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 999;
  background-color: white;
  border-radius: 0 50% 50% 0;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
}
.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.bounce-arrow {
  animation: bounce 1s infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px);
  }
}
</style>
